module.exports = __webpack_public_path__ + "img/thinking-process-doing.819a153.gif";